import React from "react";
import { CollaboratorListContainer } from "./__styles__/CollaboratorList";
import { CollaboratorRow } from "./CollaboratorRow";
import { Collaborator, PermissionOption } from "./types";

interface CollaboratorListProps {
  collaborators: Collaborator[];
  permissionOptions: PermissionOption[];
  onPermissionChange: (collaboratorId: string, permission: string) => void;
  onRemove: (collaboratorId: string) => void;
  showPermissionOptions?: boolean;
}

export const CollaboratorList = ({
  collaborators,
  permissionOptions,
  onPermissionChange,
  onRemove,
  showPermissionOptions = true,
}: CollaboratorListProps) => {
  return (
    <CollaboratorListContainer>
      {collaborators.map(collaborator => (
        <CollaboratorRow
          key={collaborator.id}
          collaborator={collaborator}
          permissionOptions={permissionOptions}
          onPermissionChange={onPermissionChange}
          onRemove={onRemove}
          showPermissionOptions={showPermissionOptions}
        />
      ))}
    </CollaboratorListContainer>
  );
};
